import { render, staticRenderFns } from "./sendcover.vue?vue&type=template&id=3eaf741f&"
import script from "./sendcover.vue?vue&type=script&lang=js&"
export * from "./sendcover.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports